/* eslint-disable max-len */
import { GetEasyBasketOperationDetailResponse } from '@1po/1po-bff-fe-spec/generated/catalog/easy_basket/response/GetEasyBasketOperationDetailResponse';
import { GetEasyBasketOperationsResponse } from '@1po/1po-bff-fe-spec/generated/catalog/easy_basket/response/GetEasyBasketOperationsResponse';
import { put, takeEvery } from '@redux-saga/core/effects';
import { SagaIterator } from 'redux-saga';
import { RootState } from 'app/AppStore';
import { getVehicleContext } from 'domains/catalog/Catalog.store';
import {
  sendEasyBasketOperationDetailsRequest,
  sendEasyBasketOperationsRequest,
} from 'domains/easyBasket/EasyBasket.api';
import * as actions from 'domains/easyBasket/EasyBasket.store';
import {
  setOperations,
  setOperationsDetails,
  setOperationsDetailsStatus,
  setOperationsStatus,
} from 'domains/easyBasket/EasyBasket.store';
import { getUserContext } from 'domains/user';
import { WsResponse } from 'domains/webSockets/WebSocket.types';
import { LOADING, sagaGuard, select } from 'utils';

export function* fetchEasyBasketOperationsRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchEasyBasketOperationsRequestSaga>): SagaIterator {
  const { vehicleKey, operationsIds } = payload;
  const userContext = yield* select(getUserContext);
  const vehicleContext = yield* select((state: RootState) => getVehicleContext(state, vehicleKey));
  yield put(setOperationsStatus({ operationsIds, searchStatus: LOADING }));
  yield put(sendEasyBasketOperationsRequest({ vehicleContext, userContext, operationsIds }));
}

export function* fetchEasyBasketOperationsResponseSaga(
  action: WsResponse<GetEasyBasketOperationsResponse>,
): SagaIterator {
  const { operations } = action.payload;
  yield put(setOperations({ operations }));
}

export function* fetchEasyBasketOperationDetailsRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchEasyBasketOperationDetailsRequestSaga>): SagaIterator {
  const { vehicleKey, operationsIds, genericParts } = payload;
  const userContext = yield* select(getUserContext);
  const vehicleContext = yield* select((state: RootState) => getVehicleContext(state, vehicleKey));
  yield put(setOperationsDetailsStatus({ operationsIds, searchStatus: LOADING }));
  yield put(sendEasyBasketOperationDetailsRequest({ vehicleContext, userContext, operationsIds, genericParts }));
}

export function* fetchEasyBasketOperationDetailsResponseSaga(
  action: WsResponse<GetEasyBasketOperationDetailResponse>,
): SagaIterator {
  const { operationsDetails } = action.payload;
  yield put(setOperationsDetails({ operationsDetails }));
}

export function* EasyBasketSagas(): SagaIterator {
  yield takeEvery(actions.fetchEasyBasketOperationsRequestSaga.type, sagaGuard(fetchEasyBasketOperationsRequestSaga));
  yield takeEvery(actions.fetchEasyBasketOperationsResponseSaga.type, sagaGuard(fetchEasyBasketOperationsResponseSaga));
  yield takeEvery(
    actions.fetchEasyBasketOperationDetailsRequestSaga.type,
    sagaGuard(fetchEasyBasketOperationDetailsRequestSaga),
  );
  yield takeEvery(
    actions.fetchEasyBasketOperationDetailResponseSaga.type,
    sagaGuard(fetchEasyBasketOperationDetailsResponseSaga),
  );
}
